import { FieldLayout, fieldClassName } from "./input-field";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@verse_core/shared_components/ClassName";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

type SelectFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  onBlur?: () => void;
  error?: string | null;
  inline?: boolean;
  placeholder?: string;
  autoComplete?: string;
};

/** Rebrand dropdown, styled and labelled like InputField, e.g. the sign-up
 * state. An empty value shows the placeholder. */
export function SelectField({
  id,
  label,
  value,
  onChange,
  options,
  onBlur,
  error,
  inline,
  placeholder = "(select)",
  autoComplete,
}: SelectFieldProps) {
  return (
    <FieldLayout id={id} label={label} error={error} inline={inline}>
      <div className="tw-relative">
        <select
          id={id}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          autoComplete={autoComplete}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
          className={cn(
            fieldClassName(error),
            "tw-cursor-pointer tw-appearance-none tw-py-0 tw-pr-[32px]",
            !value && "tw-text-verse-text-disabled",
          )}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <FontAwesomeIcon
          icon={faChevronDown}
          aria-hidden="true"
          className="tw-pointer-events-none tw-absolute tw-right-[10px] tw-top-1/2 tw-h-[16px] tw-w-[16px] -tw-translate-y-1/2 tw-text-verse-icon-primary"
        />
      </div>
    </FieldLayout>
  );
}
